import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  /* Utilities kept intact */
  smallPagination: {
    "& .MuiTablePagination-caption": { flexShrink: 0, fontSize: 12 },
    "& .MuiTablePagination-selectRoot": { fontSize: 12 },
    "& .MuiTablePagination-displayedRows": { fontSize: 12 },
    "& .MuiTablePagination-actions .MuiIconButton-root": { padding: 4 },
    "& .MuiTablePagination-actions svg": { fontSize: 16 },
  },
  modal: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  paper: { backgroundColor: '#fff', boxShadow: 'none' },
  inputRoot: {
    height: 32,
    padding: '5px 8px 6px 8px',
    borderRadius: 4,
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(213, 214, 221, 1)',
    },
  },
  inputRoot1: {
    height: 32,
    width: 250,
    padding: '5px 8px 6px 8px',
    borderRadius: 4,
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(213, 214, 221, 1)',
    },
  },

  /* ===== Base (≥1441) ===== */
  sectionPadding: { padding: '24px 24px 24px 24px', boxSizing: 'border-box' },

  banner: {
    height: 86,
    border: '1px dashed #3F51B5',
    borderRadius: 8,
    background: 'linear-gradient(90deg, #F8F9FF 24.76%, #F4F6FF 100%)',
    overflow: 'hidden',
    position: 'relative',
    padding: '24px 135px',
    boxSizing: 'border-box',
  },
  bannerImg: {
    height: 82,
    width: 82,
    position: 'absolute',
    transform: 'rotate(-10.26deg)',
    bottom: -7,
    left: 25,
  },
  bannerRow: { display: 'flex', gap: 12 },
  bannerBtn: {
    height: 36,
    width: 140,
    padding: 12,
    backgroundColor: 'transparent',
    borderRadius: 4,
    border: '1px solid #3F51B5',
    color: '#3F51B5',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': { backgroundColor: 'transparent', borderColor: '#3F51B5', boxShadow: 'none' },
  },
  bannerTextWrap: { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 },
  bannerSubHeading: {
    fontSize: 12, fontWeight: 400, lineHeight: '17px', color: 'rgba(69, 70, 83, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%',
  },
  bannerTopHeading: {
    fontSize: 12, fontWeight: 400, lineHeight: '17px', color: 'rgba(146, 147, 166, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%',
  },

  tableSection: {
    padding: '24px 24px 24px 24px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  tableTitle: {
    fontSize: 14, fontWeight: 400, lineHeight: '21px', color: 'rgba(43, 44, 53, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
  },

  /* ===== ≤1440px (new) ===== */
  '@media (max-width:1440px)': {
    sectionPadding: { padding: 22 },
    banner: {
      height: 84,
      padding: '22px 120px',
    },
    bannerImg: {
      height: 78,
      width: 78,
      bottom: -6,
      left: 18,
    },
    bannerRow: { gap: 12 },
    bannerBtn: { width: 136, height: 34, padding: 10, fontSize: 12 },
    bannerSubHeading: { fontSize: 12, lineHeight: '16px' },
    bannerTopHeading: { fontSize: 12, lineHeight: '16px' },

    tableSection: { padding: 22, gap: 8 },
    tableTitle: { fontSize: 13, lineHeight: '20px' },
  },

  /* ===== ≤1280px ===== */
  '@media (max-width:1280px)': {
    sectionPadding: { padding: 20 },
    banner: { height: 82, padding: '20px 100px' },
    bannerImg: { height: 72, width: 72, bottom: -6, left: 16 },
    bannerRow: { gap: 10 },
    bannerBtn: { width: 128, height: 34, padding: 10, fontSize: 12 },
    bannerSubHeading: { fontSize: 12 },
    bannerTopHeading: { fontSize: 12 },

    tableSection: { padding: 20, gap: 8 },
    tableTitle: { fontSize: 13, lineHeight: '20px' },
  },

  /* ===== ≤1024px ===== */
  '@media (max-width:1024px)': {
    sectionPadding: { padding: 16 },
    banner: { height: 76, padding: '16px 88px' },
    bannerImg: { height: 64, width: 64, bottom: -6, left: 12 },
    bannerRow: { gap: 10 },
    bannerBtn: { width: 120, height: 32, padding: 10, fontSize: 12 },
    bannerTextWrap: { gap: 3 },
    bannerSubHeading: { fontSize: 11, lineHeight: '16px' },
    bannerTopHeading: { fontSize: 11, lineHeight: '16px' },

    tableSection: { padding: 16, gap: 8 },
    tableTitle: { fontSize: 12, lineHeight: '18px' },
  },
}));

export default useStyles;
